export default class ForeignPersonalInfoRepository {

  get(id) {
    // Aquí implementa la lógica para obtener la información de una entidad por su ID
  }

  save(entity) {
    // Aquí implementa la lógica para guardar una entidad en el repositorio
  }
}